import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const rolesService = {
  getRoles,
  getRolesPermission,
};

function getRoles(params) {
  return apiCall("GET", API_URLS.USERS.GET_ROLES_ADMIN, null, null, params);
}

function getRolesPermission(id){
  console.log(id)
  return apiCall("GET", `${API_URLS.ROLES.GET_PERMISSIONS_ROLE}/${id}`, null, null, null);
}